import { cn } from '@/lib/utils'
import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu'
import React, { useContext, useEffect, useRef } from 'react'

import { NavigationMenuContext } from '@/components/_headers/_shared/navigationMenuContext'
import NavigationMenuViewport from './NavigationItems/Viewport'

const NavigationMenuItem = NavigationMenuPrimitive.Item
const NavigationMenuLink = NavigationMenuPrimitive.Link

const NavigationMenu = React.forwardRef<
  React.ElementRef<typeof NavigationMenuPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof NavigationMenuPrimitive.Root>
>(({ className, children, ...props }, ref) => {
  const {
    setIsNavigationMenuOpen,
    setNavigationMenuValue,
    offsetHeight,
    setOffsetHeight,
  } = useContext(NavigationMenuContext)
  const targetRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    setTimeout(() => {
      if (
        targetRef.current &&
        targetRef.current.offsetHeight !== offsetHeight
      ) {
        // Minus border
        setOffsetHeight(targetRef.current.offsetHeight - 1)
      }
    }, 100)
  }, [targetRef, offsetHeight, setOffsetHeight])

  return (
    <NavigationMenuPrimitive.Root
      onValueChange={(open): void => {
        setNavigationMenuValue(open)
        if (open !== '') {
          document.body.style.overflow = 'hidden'
          setIsNavigationMenuOpen(true)
          return
        }

        document.body.style.overflow = 'unset'
        setIsNavigationMenuOpen(false)
      }}
      ref={ref}
      className={cn(
        'relative flex max-w-max flex-1 items-center justify-center',
        className,
      )}
      {...props}
    >
      <div ref={targetRef}>{children}</div>

      <NavigationMenuViewport />
    </NavigationMenuPrimitive.Root>
  )
})

NavigationMenu.displayName = NavigationMenuPrimitive.Root.displayName

export { NavigationMenu, NavigationMenuItem, NavigationMenuLink }

export { default as NavigationMenuList } from './NavigationItems/List'
export { default as NavigationMenuContent } from './NavigationItems/Content'
export { default as NavigationMenuIndicator } from './NavigationItems/Indicator'
export { default as NavigationMenuTrigger } from './NavigationItems/Trigger'
export { default as NavigationMenuViewport } from './NavigationItems/Viewport'
